import type { FormValues } from './ExportDrawer.types'

export const MODAL_NAME = 'orders.export'
export const FORM_ID = 'orders.export'

export const INITIAL_VALUES: FormValues = {
  carrierId: '',
  customerFirstName: '',
  customerLastName: '',
  dateType: '',
  endDate: '',
  encoding: '',
  isBackship: '',
  language: '',
  market: '',
  orderId: '',
  sku: '',
  startDate: '',
  state: '',
}
